import { ApiClient } from '../../api/ApiClient';
import { v2 } from '../../api/ApiInterfaceV2';
import { Arr } from '../../CodesForFoundation';
import { SessionStorageService } from '../../platform/StorageService';
import { AccountModel } from '../account/AccountModel';
import { AppEvents } from '../AppEvents';
import { PassportModel } from '../PassportModel';
import { createScope } from '../Scope';
import { AllBoardsActiveViewModel } from './AllBoardsActiveViewModel';

// const onBoardCreate = (broker: ModelBroker) => (e: AppEventStreams['board:create']) => {
//     // If for some reason (race condition) we already have, just exit
//     if (broker.has(AllBoardModel, e.board.id)) return;
//     // Create the new model
//     const board = broker.allocate(AllBoardModel, e.board);
//     // Add to model
//     broker.get(AllBoardsListModel)(x => x.push(board));
// };

// const onBoardDelete = (broker: ModelBroker) => (e: AppEventStreams['board:delete']) => {
//     const board = broker.get(AllBoardModel, e.boardId);
//     if (board) {
//         broker.get(AllBoardsListModel).update(x => Arr.remove(x, board));
//         broker.release(board);
//     }
// };

// const onBoardPatch = (broker: ModelBroker) => (e: AppEventStreams['board:patch']) =>
//     broker.get(AllBoardModel, e.board.id)?.mutate(e.board);

export const AllBoardsScope = createScope({
    async refresh(p, c) {

        const api = c.get(ApiClient);
        const account = c.get(AccountModel);
        const evts = c.get(AppEvents);
        const tempData = c.get(SessionStorageService);

        const defaultWorkspace = account.workspaces.find(x => x.type === 'default');
        const permissionsData = await api.exec(v2.me.permissions(['workspace', defaultWorkspace?.id]));

        const [model, updateModel] = AllBoardsActiveViewModel.create(api, tempData);
        await model.refresh();

        c.bind(AllBoardsActiveViewModel).toConstantValue(model);
        c.bind(PassportModel).toConstantValue(PassportModel.create(permissionsData));

        return [
            evts.on('board:create', () => void (model.refresh())),
            evts.on('board:move', () => void (model.refresh())),
            evts.on('board:delete', ({ boardId }) => updateModel(({ items }) => {
                Arr.removeWhere(items, x => x.id === boardId);
            })),
            evts.on('board:patch', ({ board }) => updateModel(({ items }) => {
                items.find(x => x.id === board.id)?.mutate(board);
            })),
        ];
    }
});
